import { Component, Input } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-linkdin-evaluation',
  templateUrl: './linkdin-evaluation.component.html',
  styleUrls: ['./linkdin-evaluation.component.css'],
})
export class LinkdinEvaluationComponent {
  @Input() selectedprofile: any;

  profileScores: any = {};
  scanResultData: any = null;
  jobRanking: any = null;
  openLists: Record<string, boolean> = {};
  contentData: any;
  imagePath = environment.apiUrl;

  constructor(
    private content: FetchDataService,
    private translate: TranslateService
  ) {}

ngOnInit(): void {
  try {

    let evaluation = this.selectedprofile?.linkedInEvaluation
      ?? this.selectedprofile?.evaluation
      ?? this.selectedprofile;  
    if (!evaluation) {

      this.scanResultData = null;
      return;
    }

    if (typeof evaluation === 'string') {
      evaluation = JSON.parse(evaluation);
    }

    if (!evaluation || typeof evaluation !== 'object') {
      this.scanResultData = null;
      return;
    }

    const formatData = evaluation.formatResponse ?? evaluation;
    this.scanResultData = formatData;
    this.jobRanking = evaluation.jobRankingResponse ?? null;

      const manualScore = this.calculateScore(this.scanResultData);
      this.profileScores.total = this.jobRanking?.overallScore != null
        ? parseFloat(((this.jobRanking.overallScore + manualScore) / 2).toFixed(1))
        : manualScore;
      this.profileScores.headline   = this.calculateScore(formatData.headline);
      this.profileScores.summary    = this.calculateScore(formatData.summary);
      this.profileScores.experience = this.calculateScore(formatData.experience);
      this.profileScores.education  = this.calculateScore(formatData.education);
      this.profileScores.technical  = this.calculateScore(formatData.technical);

  } catch (e) {
    console.error('Error parsing linkedInEvaluation:', e);
    this.scanResultData = null;
  }

  this.loadContent(this.translate.currentLang);
  this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    this.loadContent(event.lang);
  });
}

  loadContent(lang: string): void {
    this.content.getContentData(lang, 'scan-linkedin-result').subscribe({
      next: (data) => {
        this.contentData = data;
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  toggleList(key: string): void {
    this.openLists[key] = !this.openLists[key];
  }

  getCircleDash(score: number): string {
    const circumference = 2 * Math.PI * 15.9;
    const filled = (score / 100) * circumference;
    return `${filled} ${circumference}`;
  }

  getCheckIcon(fieldName: string): string {
    const fieldValue = this.findFieldValue(this.scanResultData, fieldName);
    if (fieldValue === 1) {
      return 'assets/icon/right check.png';
    }
    return 'assets/icon/wrong-check.png';
  }

  private findFieldValue(data: any, fieldName: string): any {
    if (data === null || data === undefined) return undefined;

    if (Array.isArray(data)) {
      for (const item of data) {
        const result = this.findFieldValue(item, fieldName);
        if (result !== undefined) return result;
      }
    } else if (typeof data === 'object') {
      for (const key in data) {
        if (key === fieldName) return data[key];
        const result = this.findFieldValue(data[key], fieldName);
        if (result !== undefined) return result;
      }
    }

    return undefined;
  }

  calculateScore(data: any): number {
    let total = 0;
    let count = 0;

    function traverseAndScore(section: any) {
      if (Array.isArray(section)) {
        section.forEach((item) => traverseAndScore(item));
      } else if (section && typeof section === 'object') {
        Object.values(section).forEach((value) => {
          if (typeof value === 'number') {
            total += value;
            count++;
          } else {
            traverseAndScore(value);
          }
        });
      }
    }

    traverseAndScore(data);
    return count > 0 ? parseFloat(((total / count) * 100).toFixed(1)) : 0;
  }

  getTitleAndDescription(
    section: string,
    key: string
  ): { title: string; description: string } {
    if (!this.contentData) return { title: '', description: '' };

    const sectionData = this.contentData[section];

    if (Array.isArray(sectionData)) {
      for (const entry of sectionData) {
        if (entry[key]) {
          return { title: entry[key].title, description: entry[key].description };
        }
      }
    } else if (sectionData && sectionData[key]) {
      return { title: sectionData[key].title, description: sectionData[key].description };
    }

    return { title: '', description: '' };
  }

  getKeys(obj: any): string[] {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return [];
    return Object.keys(obj);
  }

  downloadFile(path: string) {
    const link = document.createElement('a');
    link.href = this.imagePath + path;
    link.download = path.split('/').pop() || 'download';
    link.click();
  }
}